// アンカーリンク
$(function () {
  $('a[href^="#"]').click(function () {
    let speed = 800;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? "html" : href);
    let position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

/* ハンバーガーメニュー */
let triggerBtn = document.querySelector(".js_triggerBtn");
let triggerMenu = document.querySelector(".p_hamburgerNav");
let body = document.querySelector("body");
triggerBtn.addEventListener("click", function () {
  triggerBtn.classList.toggle("is-active");
  if (triggerBtn.classList.contains("is-active")) {
    triggerMenu.classList.add("is-active");
    body.classList.add("is-fixed");
  } else {
    triggerMenu.classList.remove("is-active");
    body.classList.remove("is-fixed");
  }
});


function megamenuOpen(trigger) {
  trigger.classList.add("is-active");
  trigger.querySelectorAll('.p_megamenu').forEach(x=>{
    x.classList.add("is-active");
  });
  document.querySelectorAll('.l_bgMask').forEach(x=>{
    x.classList.add("is-active");
  });
  document.querySelector('html').classList.add("is-fixed");
  document.body.classList.add("is-fixed");
}

function megamenuClose() {
  document.querySelectorAll('.p_megamenuOpen').forEach(x=>{
    x.classList.remove("is-active");
  });
  document.querySelectorAll('.p_megamenu').forEach(x=>{
    x.classList.remove("is-active");
  });
  document.querySelectorAll('.l_bgMask').forEach(x=>{
    x.classList.remove("is-active");
  });
  document.querySelector('html').classList.remove("is-fixed");
  document.body.classList.remove("is-fixed");
}


document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('.p_megamenuOpen').forEach(x=>{
    x.addEventListener("click",()=>{
      if(x.classList.contains("is-active")){
        megamenuClose();
      }
      else
      {
        megamenuOpen(x);
      }
    });
  });
  document.querySelectorAll('.b_megamenu_item a').forEach(x=>{
    x.addEventListener("click",()=>{
      megamenuClose();
    });
  });
  document.querySelectorAll(".l_bgMask").forEach(x=>{
    x.addEventListener("click",()=>{
      megamenuClose();
    });
  });
});

const acc_ttl = Array.from(
  document.querySelectorAll(".e_acTtl")
);

for (let i = 0; i < acc_ttl.length; i++) {
  let ttl = acc_ttl[i];
  let content = ttl.children[1]
  ttl.addEventListener("click", () => {
    ttl.classList.toggle("is-active");
    console.log(content.style.height);
    if (content.style.height) {
      content.style.height = null;
    } else {
      content.style.height = content.scrollHeight + "px";
    }
  });
}


